import React, { Component } from "react";
import { history } from "../../../helper/history.js";
import { AzureStorageManage } from "../../../helper/azureStorageManage.js";
import config from "../../../helper/config.js";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import CardBody from "../../../components/common/CardBody.js";
import { Row, Col, Spinner, Form, Modal, Dropdown } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Collapse,
  Card,
  CardContent,
  CardHeader,
  IconButton,
} from "@mui/material";
import { Button } from "react-bootstrap";
import { EditorState } from "draft-js";
import { namespace } from "../../../helper/namespace.js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { DocumentService } from "../../../service/manage/lms/document_service.js";
import { DeadlineService } from "../../../service/manage/lms/deadline_service.js";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import { customerConstants } from "../../../helper/constants.js";
import TimeZoneHandler from "../../../handlers/TimeZoneHandler.js";
import CheckBox from "../../../components/common/form/CheckBox.js";
import CheckBoxInline from "../../../components/common/form/CheckBoxInline.js";
import {
  sweetStatusAlert,
  sweetSuccessAlert,
} from "../../../components/common/SweetAlert.js";
import DeleteIcon from "@mui/icons-material/Delete";
import CourseMaterialsSkeleton from "./CourseMaterialsSkeleton.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let cancelClass, confirmClass;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    cancelClass = "btn-default";
    confirmClass = "btn-primary";
    break;
  case customerConstants.EXO_CUSTOMER2:
  default:
    cancelClass = "btn-default";
    confirmClass = "btn-primary";
    break;
}

// Updated document types configuration
const DOCUMENT_TYPES = {
  LEARNING_MATERIALS: {
    name: "Learning Materials",
    icon: "📚",
    color: "#4285f4",
  },
  RECORDINGS: { name: "Recordings", icon: "🎥", color: "#ea4335" },
  REFERENCES: { name: "References", icon: "📖", color: "#34a853" },
  TASKS: { name: "Tasks", icon: "📝", color: "#fbbc04" },
  PRACTICE_TESTS: { name: "Practice Tests", icon: "📊", color: "#9c27b0" },
  OTHER: { name: "Other", icon: "📄", color: "#ff9800" },
};

const ALLOWED_FILE_TYPES = [
  "video/mp4", // MP4
  "video/quicktime", // MOV
];

class ManageDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Topic management
      topics: [],
      topicDocuments: new Map(), // topic_id -> documents array
      expandedTopics: new Set(), // Set of expanded topic IDs

      // Topic creation/editing
      showTopicModal: false,
      editingTopic: null,
      topicFormData: {
        topic_name: "",
        topic_description: "",
      },

      // Document management
      showDocumentModal: false,
      selectedDocumentType: "",
      selectedTopic: null,
      selectedFile: null,

      // Bulk operations
      selectedFiles: [],
      allSelected: false,

      // UI states
      loading: false,
      loadingModal: false,

      // User permissions
      userType: null,
      editVisibility: false,
      addVisibility: false,
      deleteVisibility: false,
      viewVisibility: false,

      // Node information
      node_id: "",
      manage_user_id: "",
      user_table_id: "",
      breadcrumb2: null,
      nodeTitle: null,

      // Network state
      isConnected: window.navigator.onLine,
    };
  }

  componentDidMount() {
    this.initializeComponent();
  }

  initializeComponent = async () => {
    const { privilege_view, privilege_add, privilege_edit, privilege_delete } =
      this.props.state;

    this.setUserPermissions(
      privilege_view,
      privilege_add,
      privilege_delete,
      privilege_edit
    );

    const userType = sessionStorage.getItem("userType");
    const node_mid_actual =
      this.props.state.node_mid_actual !== null
        ? this.props.state.node_mid_actual
        : this.props.state.mid;


    await new Promise((resolve) =>
      this.setState(
        {
          userType,
          node_id: node_mid_actual,
          manage_user_id: sessionStorage.getItem("manage_user_id"),
          user_table_id: sessionStorage.getItem("table_log_id"),
          breadcrumb2: this.props.state.breadcrumb2,
          nodeTitle: this.props.state.breadcrumb2,
        },
        resolve
      )
    );

await this.loadTopicsAndDocuments();

  };

  setUserPermissions = (
    privilege_view,
    privilege_add,
    privilege_delete,
    privilege_edit
  ) => {
    this.setState({
      addVisibility: privilege_add === 1,
      editVisibility: privilege_edit === 1,
      viewVisibility: privilege_view === 1,
      deleteVisibility: privilege_delete === 1,
    });
  };

  loadTopicsAndDocuments = async () => {
    this.setState({ loading: true });

    const NodeId =
      this.props.state.node_mid_actual !== null
        ? this.props.state.node_mid_actual
        : this.props.state.mid;

    try {
      // Load topics and documents in parallel for better performance
      const [topicsResponse, documentsResponse] = await Promise.all([
        DocumentService.getTopicsByNodeId(NodeId),
        this.getDocumentsByContainerId(),
      ]);

      const topics = topicsResponse.data || [];
      const documents = documentsResponse.data || [];

      // Efficiently map documents to topics
      const topicDocuments = this.mapDocumentsToTopics(topics, documents);

      // Auto-expand topics that have documents
      const expandedTopics = new Set();

      this.setState({
        topics,
        topicDocuments,
        expandedTopics,
      });
    } catch (error) {
      console.error("Error loading topics and documents:", error);
      this.showErrorMessage("Failed to load content. Please try again.");
    } finally {
      this.setState({ loading: false });
    }
  };

  getDocumentsByContainerId = async () => {
    const NodeId =
      this.props.state.node_mid_actual !== null
        ? this.props.state.node_mid_actual
        : this.props.state.mid;


    const form_list = this.props.state.form_list_id;
    const containerId = `${NodeId}_${form_list}`
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, "-")
      .replace(/^-+|-+$/g, "");

    return DocumentService.getDocumentsByContainerId(containerId);
  };

  mapDocumentsToTopics = (topics, documents) => {
    const topicDocuments = new Map();

    // Initialize all topics with empty arrays
    topics.forEach((topic) => {
      topicDocuments.set(topic.topic_id, []);
    });

    // Group documents by topic_id with O(n) efficiency
    documents.forEach((doc) => {
      const topicId = doc.topic_id;
      if (topicDocuments.has(topicId)) {
        topicDocuments.get(topicId).push(doc);
      } else {
        // Handle documents without valid topic_id - create "Uncategorized" topic
        if (!topicDocuments.has(0)) {
          topicDocuments.set(0, []);
        }
        topicDocuments.get(0).push(doc);
      }
    });

    return topicDocuments;
  };

  // Topic Management Methods
  handleCreateTopic = () => {
    this.setState({
      showTopicModal: true,
      editingTopic: null,
      topicFormData: {
        topic_name: "",
        topic_description: "",
      },
    });
  };

  handleEditTopic = (topic) => {
    this.setState({
      showTopicModal: true,
      editingTopic: topic,
      topicFormData: {
        topic_name: topic.topic_name,
        topic_description: topic.topic_description,
      },
    });
  };

  handleTopicFormChange = (field, value) => {
    this.setState((prevState) => ({
      topicFormData: {
        ...prevState.topicFormData,
        [field]: value,
      },
    }));
  };

  handleTopicSubmit = async () => {
    const {
      topicFormData,
      editingTopic,
      node_id,
      manage_user_id,
      user_table_id,
    } = this.state;

    if (!topicFormData.topic_name.trim()) {
      this.showErrorMessage("Topic name is required!");
      return;
    }

    this.setState({ loadingModal: true });

    const payload = {
      topic_name: topicFormData.topic_name.trim(),
      topic_description: topicFormData.topic_description.trim(),
      node_id: node_id,
      create_user_id: manage_user_id,
      create_user_table_id: user_table_id,
    };

    try {
      if (editingTopic) {
        await DocumentService.updateTopic(editingTopic.topic_id, payload);
        this.showSuccessMessage(
          `Topic "${payload.topic_name}" updated successfully!`
        );
      } else {
        await DocumentService.addTopic(payload);
        this.showSuccessMessage(
          `Topic "${payload.topic_name}" created successfully!`
        );
      }

      this.handleCloseTopicModal();
      await this.loadTopicsAndDocuments();
    } catch (error) {
      console.error("Error saving topic:", error);
      this.showErrorMessage("Failed to save topic. Please try again.");
    } finally {
      this.setState({ loadingModal: false });
    }
  };

  handleCloseTopicModal = () => {
    this.setState({
      showTopicModal: false,
      editingTopic: null,
      topicFormData: {
        topic_name: "",
        topic_description: "",
      },
    });
  };

  toggleTopicExpansion = (topicId) => {
    this.setState((prevState) => {
      const expandedTopics = new Set(prevState.expandedTopics);
      if (expandedTopics.has(topicId)) {
        expandedTopics.delete(topicId);
      } else {
        expandedTopics.add(topicId);
      }
      return { expandedTopics };
    });
  };

  // Document Management Methods
  handleCreateDocument = (topic) => {
    this.setState({
      showDocumentModal: true,
      selectedTopic: topic,
      selectedDocumentType: "",
      selectedFile: null,
    });
  };

  handleFileRemove = () => {
    this.setState({
      selectedFile: null,
    });
    const fileInput = document.getElementById("documentFileInput");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  // Updated handleDocumentTypeSelect method
  handleDocumentTypeSelect = (documentType) => {
    if (!this.state.selectedFile) {
      this.setState({
        selectedDocumentType: documentType,
        selectedFile: null,
      });
    }
  };

  handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    if (this.state.selectedDocumentType === "RECORDINGS") {
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        this.showErrorMessage(
          "Only video files are allowed! Supported formats: MP4, MOV"
        );
        event.target.value = "";
        return;
      }
    }

    this.setState({
      selectedFile: file,
    });
  };

  handleDocumentUpload = async () => {
    const {
      selectedFile,
      selectedDocumentType,
      selectedTopic,
      node_id,
      manage_user_id,
      user_table_id,
    } = this.state;

    if (!selectedFile) {
      this.showErrorMessage("Please select a file!");
      return;
    }
    if (!selectedDocumentType) {
      this.showErrorMessage("Please select a document type!");
      return;
    }
    if (!selectedTopic) {
      this.showErrorMessage("Topic is required!");
      return;
    }

    this.setState({ loadingModal: true });

    const form_list = this.props.state.form_list_id;
    const container_id = `${node_id}_${form_list}`
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, "-")
      .replace(/^-+|-+$/g, "");

    const originalName = selectedFile.name;
    const timestamp = Date.now();
    const fileExtension = originalName.substring(originalName.lastIndexOf("."));
    const fileNameWithoutExt = originalName.substring(
      0,
      originalName.lastIndexOf(".")
    );
    const uniqueName = `${fileNameWithoutExt}_${timestamp}${fileExtension}`;

    const size = selectedFile.size;

    if (size > config.fileUploadConfigs.maxFileSize) {
      this.showErrorMessage("File size exceeds maximum allowed limit!");
      this.setState({ loadingModal: false });
      return;
    }

    try {
      const fileContent = await this.readFile(selectedFile);

      // Upload with unique name to prevent conflicts
      await AzureStorageManage.uploadBlob(
        container_id,
        uniqueName,
        fileContent
      );

      await DocumentService.addDocument({
        document_name: uniqueName, // Store the unique name in database
        node_id: node_id,
        container_id: container_id,
        user_id: manage_user_id,
        user_table_id: user_table_id,
        create_user_id: manage_user_id,
        create_user_table_id: user_table_id,
        document_type: selectedDocumentType,
        topic_id: selectedTopic.topic_id,
      });

      // Show success message with original name for better UX
      this.showSuccessMessage(
        `${DOCUMENT_TYPES[selectedDocumentType].name} "${originalName}" uploaded successfully!`
      );

      this.handleCloseDocumentModal();
      await this.loadTopicsAndDocuments();
    } catch (error) {
      console.error("Upload error:", error);
      this.showErrorMessage("Failed to upload file. Please try again.");
    } finally {
      this.setState({ loadingModal: false });
    }
  };

  handleCloseDocumentModal = () => {
    this.setState({
      showDocumentModal: false,
      selectedTopic: null,
      selectedDocumentType: "",
      selectedFile: null,
    });
  };

  readFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => resolve(event.target.result);
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  };

  // File Operations
  handleDownloadFile = async (containerName, blobName) => {
    try {
      await AzureStorageManage.downloadBlob(containerName, blobName);
    } catch (error) {
      console.error("Error downloading file:", error);
      this.showErrorMessage("Failed to download file.");
    }
  };

  handleDeleteFile = async (containerName, blobName, document_id) => {
    const result = await window.Swal.fire({
      title: "Are you sure?",
      text: `You are about to delete "${blobName}". This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      customClass: {
        confirmButton: `btn font-weight-bold ${confirmClass}`,
        cancelButton: `btn font-weight-bold ${cancelClass}`,
      },
    });

    if (!result.isConfirmed) return;

    this.setState({ loading: true });

    try {
      await AzureStorageManage.deleteblob(containerName, blobName);
      await DocumentService.deleteDocument(document_id);

      this.showSuccessMessage(`File "${blobName}" deleted successfully!`);
      await this.loadTopicsAndDocuments();
    } catch (error) {
      console.error("Error deleting file:", error);
      this.showErrorMessage("Failed to delete file.");
    } finally {
      this.setState({ loading: false });
    }
  };

  handleDeleteTopic = async (topic) => {
    const { topicDocuments } = this.state;
    const documents = topicDocuments.get(topic.topic_id) || [];
    const hasDocuments = documents.length > 0;

    // Prepare confirmation dialog content
    let confirmationText = `You are about to delete the topic "${topic.topic_name}".`;
    let confirmationHtml = "";

    if (hasDocuments) {
      const documentList = documents
        .map((doc) => `• ${doc.document_name}`)
        .join("<br>");

      confirmationText = `You are about to delete the topic "${topic.topic_name}" and all its documents.`;
      confirmationHtml = `
      <div style="text-align: left; margin-top: 15px;">
        <strong>The following ${documents.length} document${
        documents.length > 1 ? "s" : ""
      } will also be deleted:</strong>
        <div style="margin-top: 10px; padding: 10px; background-color: #f8f9fa; border-radius: 4px; max-height: 200px; overflow-y: auto;">
          ${documentList}
        </div>
      </div>
      <div style="margin-top: 15px; color: #d32f2f; font-weight: bold;">
        This action cannot be undone.
      </div>
    `;
    } else {
      confirmationText += " This action cannot be undone.";
    }

    // Show confirmation dialog
    const result = await window.Swal.fire({
      title: "Are you sure?",
      text: hasDocuments ? undefined : confirmationText,
      html: hasDocuments
        ? `<p>${confirmationText}</p>${confirmationHtml}`
        : undefined,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: hasDocuments
        ? "Yes, delete topic and all documents!"
        : "Yes, delete topic!",
      cancelButtonText: "Cancel",
      customClass: {
        confirmButton: `btn font-weight-bold ${confirmClass}`,
        cancelButton: `btn font-weight-bold ${cancelClass}`,
      },
      width: hasDocuments ? "600px" : undefined,
    });

    if (!result.isConfirmed) return;

    this.setState({ loading: true });

    try {
      if (hasDocuments) {
        await Promise.all(
          documents.map((doc) =>
            AzureStorageManage.deleteblob(
              doc.container_id,
              doc.document_name
            ).catch((e) => {
              console.error(`Failed to delete blob ${doc.document_name}:`, e);
              return Promise.resolve();
            })
          )
        );
      }

      // Delete topic and all associated documents from database
      // This method handles both cases: topics with documents and topics without documents
      await DocumentService.deleteTopicBulkDocuments(topic.topic_id);

      // Show success message
      const successMessage = hasDocuments
        ? `Topic "${topic.topic_name}" and ${documents.length} document${
            documents.length > 1 ? "s" : ""
          } deleted successfully!`
        : `Topic "${topic.topic_name}" deleted successfully!`;

      this.showSuccessMessage(successMessage);

      await this.loadTopicsAndDocuments();
    } catch (error) {
      console.error("Error deleting topic:", error);

      const errorMessage = hasDocuments
        ? "Failed to delete topic and documents. Some files may still exist."
        : "Failed to delete topic.";

      this.showErrorMessage(errorMessage);
    } finally {
      this.setState({ loading: false });
    }
  };

  // Bulk Operations
  handleSelectAllFiles = (e) => {
    const isChecked = e.target.checked;
    const { topicDocuments } = this.state;

    let allFiles = [];
    if (isChecked) {
      topicDocuments.forEach((documents) => {
        documents.forEach((doc) => {
          allFiles.push({
            container_id: doc.container_id,
            document_name: doc.document_name,
          });
        });
      });
    }

    this.setState({
      selectedFiles: allFiles,
      allSelected: isChecked,
    });
  };

  handleFileCheckboxChange = (e, document) => {
    const isChecked = e.target.checked;
    const { selectedFiles } = this.state;

    const updatedSelectedFiles = isChecked
      ? [
          ...selectedFiles,
          {
            container_id: document.container_id,
            document_name: document.document_name,
          },
        ]
      : selectedFiles.filter(
          (file) => file.document_name !== document.document_name
        );

    this.setState({
      selectedFiles: updatedSelectedFiles,
      allSelected: false, // Reset all selected when individual items change
    });
  };

  handleDownloadSelectedFiles = async () => {
    const { selectedFiles } = this.state;

    if (selectedFiles.length === 0) {
      this.showErrorMessage("No files selected for download!");
      return;
    }

    this.setState({ loading: true });

    try {
      await AzureStorageManage.downloadMultipleBlobs(
        selectedFiles[0].container_id,
        selectedFiles
      );
      this.showSuccessMessage(
        `${selectedFiles.length} file(s) downloaded successfully!`
      );
    } catch (error) {
      console.error("Error downloading files:", error);
      this.showErrorMessage("Failed to download selected files.");
    } finally {
      this.setState({ loading: false });
    }
  };

  // Utility Methods
  showSuccessMessage = (message) => {
    window.Swal.fire({
      title: "Success!",
      text: message,
      icon: "success",
      customClass: {
        confirmButton: `btn font-weight-bold ${confirmClass}`,
      },
    });
  };

  showErrorMessage = (message) => {
    window.Swal.fire({
      title: "Error!",
      text: message,
      icon: "error",
      customClass: {
        confirmButton: `btn font-weight-bold ${confirmClass}`,
      },
    });
  };

  formatDate = (dateString) => {
    if (!dateString) return "";
    const utcString = dateString.includes("Z") ? dateString : dateString + "Z";
    const date = new Date(utcString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  formatTime = (dateString) => {
    if (!dateString) return "";
    const utcString = dateString.includes("Z") ? dateString : dateString + "Z";
    const date = new Date(utcString);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  truncateFileName = (fileName, maxLength = 30) => {
    if (!fileName || fileName.length <= maxLength) return fileName;
    return fileName.substring(0, maxLength) + "...";
  };

  // Render Methods
  renderTopicCard = (topic) => {
    const { topicDocuments, expandedTopics, editVisibility, deleteVisibility } =
      this.state;
    const documents = topicDocuments.get(topic.topic_id) || [];
    const isExpanded = expandedTopics.has(topic.topic_id);
    const documentCount = documents.length;

    return (
      <div
        key={topic.topic_id}
        className="topic-card mb-4"
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          border: "1px solid #e0e0e0",
          overflow: "hidden",
        }}
      >
        {/* Topic Header */}
        <div
          className="topic-header d-flex align-items-center justify-content-between p-4"
          style={{
            backgroundColor: "#f8f9fa",
            cursor: "pointer",
            borderBottom: isExpanded ? "1px solid #e0e0e0" : "none",
          }}
          onClick={() => this.toggleTopicExpansion(topic.topic_id)}
        >
          <div className="d-flex align-items-center flex-grow-1">
            <span style={{ fontSize: "24px", marginRight: "12px" }}>📁</span>
            <div>
              <h5
                className="mb-1"
                style={{ color: "#3c4043", fontWeight: "500" }}
              >
                {topic.topic_name}
              </h5>
              {topic.topic_description && (
                <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
                  {topic.topic_description}
                </p>
              )}
            </div>
          </div>

          <div className="d-flex align-items-center">
            <span
              className="badge badge-primary mr-3"
              style={{
                backgroundColor: "#e3f2fd",
                color: "#1976d2",
                fontSize: "12px",
                padding: "4px 8px",
                borderRadius: "12px",
              }}
            >
              {documentCount} items
            </span>

            <div style={{ display: "flex", gap: "8px" }}>
              {editVisibility && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handleEditTopic(topic);
                  }}
                  style={{
                    backgroundColor: "#f0f8ff",
                    border: "1px solid #4a90e2",
                    borderRadius: "6px",
                    padding: "6px 12px",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#4a90e2",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#4a90e2";
                    e.target.style.color = "#fff";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#f0f8ff";
                    e.target.style.color = "#4a90e2";
                  }}
                  title="Edit Topic"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                  </svg>
                  Edit
                </button>
              )}

              {deleteVisibility && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handleDeleteTopic(topic);
                  }}
                  style={{
                    backgroundColor: "#fff5f5",
                    border: "1px solid #ef4444",
                    borderRadius: "6px",
                    padding: "6px 12px",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#ef4444",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#ef4444";
                    e.target.style.color = "#fff";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#fff5f5";
                    e.target.style.color = "#ef4444";
                  }}
                  title="Delete Topic"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                  </svg>
                  Delete
                </button>
              )}
            </div>

            <div
              style={{
                marginLeft: "12px",
                padding: "4px",
                borderRadius: "4px",
                backgroundColor: "rgba(0,0,0,0.05)",
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="#5f6368"
                style={{
                  transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                }}
              >
                <path d="M7 10l5 5 5-5z" />
              </svg>
            </div>
          </div>
        </div>

        {/* Topic Content */}
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <div className="topic-content">
            {/* Add Document Button */}
            {editVisibility && (
              <div className="p-3 border-bottom">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => this.handleCreateDocument(topic)}
                  style={{
                    borderRadius: "20px",
                    padding: "8px 16px",
                    fontSize: "14px",
                  }}
                >
                  ➕ Add Material
                </Button>
              </div>
            )}

            {/* Documents List */}
            <div className="documents-list">
              {documents.length === 0 ? (
                <div className="text-center py-4" style={{ color: "#5f6368" }}>
                  <p>No materials added yet.</p>
                </div>
              ) : (
                documents.map((document, index) =>
                  this.renderDocumentCard(document, index)
                )
              )}
            </div>
          </div>
        </Collapse>
      </div>
    );
  };

  renderDocumentCard = (document, index) => {
    const { deleteVisibility, selectedFiles } = this.state;
    const docType =
      DOCUMENT_TYPES[document.document_type] || DOCUMENT_TYPES.OTHER;
    const isSelected = selectedFiles.some(
      (file) => file.document_name === document.document_name
    );

    return (
      <div
        key={`${document.document_id}-${index}`}
        className="document-card p-3 border-bottom"
      >
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center flex-grow-1">
            <input
              type="checkbox"
              className="mr-3"
              checked={isSelected}
              onChange={(e) => this.handleFileCheckboxChange(e, document)}
              style={{ transform: "scale(1.2)" }}
            />

            <div
              className="document-icon mr-3"
              style={{
                fontSize: "20px",
                color: docType.color,
              }}
            >
              {docType.icon}
            </div>

            <div className="document-info flex-grow-1">
              <h6
                className="mb-1"
                style={{ color: "#3c4043", fontWeight: "500" }}
              >
                {this.truncateFileName(document.document_name)}
              </h6>
              <div
                className="d-flex align-items-center text-muted"
                style={{ fontSize: "12px" }}
              >
                <span
                  className="badge badge-light mr-2"
                  style={{
                    backgroundColor: `${docType.color}20`,
                    color: docType.color,
                    fontSize: "10px",
                  }}
                >
                  {docType.name}
                </span>
                <span>
                  {this.formatDate(document.created_at)} •{" "}
                  {this.formatTime(document.created_at)}
                </span>
              </div>
            </div>
          </div>

          <div className="document-actions">
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                onClick={() =>
                  this.handleDownloadFile(
                    document.container_id,
                    document.document_name
                  )
                }
                style={{
                  backgroundColor: "#f0f9ff",
                  border: "1px solid #0ea5e9",
                  borderRadius: "6px",
                  padding: "8px 12px",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "500",
                  color: "#0ea5e9",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  transition: "all 0.2s ease",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#0ea5e9";
                  e.target.style.color = "#fff";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#f0f9ff";
                  e.target.style.color = "#0ea5e9";
                }}
                title="Download File"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                </svg>
                Download
              </button>

              {deleteVisibility && (
                <button
                  onClick={() =>
                    this.handleDeleteFile(
                      document.container_id,
                      document.document_name,
                      document.document_id
                    )
                  }
                  style={{
                    backgroundColor: "#fff5f5",
                    border: "1px solid #ef4444",
                    borderRadius: "6px",
                    padding: "8px 12px",
                    cursor: "pointer",
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#ef4444",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#ef4444";
                    e.target.style.color = "#fff";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#fff5f5";
                    e.target.style.color = "#ef4444";
                  }}
                  title="Delete File"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                  </svg>
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderTopicModal = () => {
    const { showTopicModal, editingTopic, topicFormData, loadingModal } =
      this.state;

    // Validation logic
    const isNameValid =
      topicFormData.topic_name.trim().length > 0 &&
      topicFormData.topic_name.trim().length <= 128;
    const isDescriptionValid = topicFormData.topic_description.length <= 256;
    const isFormValid = isNameValid && isDescriptionValid;

    const nameCharCount = topicFormData.topic_name.length;
    const descriptionCharCount = topicFormData.topic_description.length;

    return (
      <Modal
        show={showTopicModal}
        onHide={this.handleCloseTopicModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{ borderBottom: "1px solid #e0e0e0" }}>
          <Modal.Title style={{ color: "#3c4043" }}>
            📁 {editingTopic ? "Update Topic" : "Create New Topic"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "24px" }}>
          <div className="form-group mb-3">
            <label
              htmlFor="topicName"
              style={{ fontWeight: "500", color: "#3c4043" }}
            >
              Topic Name *
            </label>
            <input
              type="text"
              className="form-control"
              id="topicName"
              placeholder="Enter topic name (e.g., Unit 1: Introduction)"
              value={topicFormData.topic_name}
              onChange={(e) =>
                this.handleTopicFormChange("topic_name", e.target.value)
              }
              style={{
                borderRadius: "8px",
                border: `1px solid ${
                  !isNameValid && topicFormData.topic_name.trim().length > 0
                    ? "#dc3545"
                    : "#dadce0"
                }`,
                padding: "12px 16px",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "6px",
                minHeight: "20px",
              }}
            >
              <div>
                {!isNameValid && topicFormData.topic_name.trim().length > 0 && (
                  <small style={{ color: "#dc3545", fontSize: "12px" }}>
                    {topicFormData.topic_name.trim().length === 0
                      ? "Topic name is required"
                      : "Name must be 128 characters or less"}
                  </small>
                )}
                {topicFormData.topic_name.trim().length === 0 && (
                  <small style={{ color: "#dc3545", fontSize: "12px" }}>
                    Topic name is required
                  </small>
                )}
              </div>
              <small
                style={{
                  color: nameCharCount > 128 ? "#dc3545" : "#6c757d",
                  fontSize: "12px",
                }}
              >
                {nameCharCount}/128
              </small>
            </div>
          </div>

          <div className="form-group">
            <label
              htmlFor="topicDescription"
              style={{ fontWeight: "500", color: "#3c4043" }}
            >
              Topic Description
            </label>
            <textarea
              className="form-control"
              id="topicDescription"
              rows="3"
              placeholder="Enter topic description (optional)"
              value={topicFormData.topic_description}
              onChange={(e) =>
                this.handleTopicFormChange("topic_description", e.target.value)
              }
              style={{
                borderRadius: "8px",
                border: `1px solid ${
                  !isDescriptionValid ? "#dc3545" : "#dadce0"
                }`,
                padding: "12px 16px",
                resize: "vertical",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "6px",
                minHeight: "20px",
              }}
            >
              <div>
                {!isDescriptionValid && (
                  <small style={{ color: "#dc3545", fontSize: "12px" }}>
                    Description must be 256 characters or less
                  </small>
                )}
              </div>
              <small
                style={{
                  color: descriptionCharCount > 256 ? "#dc3545" : "#6c757d",
                  fontSize: "12px",
                }}
              >
                {descriptionCharCount}/256
              </small>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #e0e0e0" }}>
          <Button
            variant="secondary"
            onClick={this.handleCloseTopicModal}
            disabled={loadingModal}
            style={{ borderRadius: "20px" }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={this.handleTopicSubmit}
            disabled={loadingModal || !isFormValid}
            style={{
              borderRadius: "20px",
              opacity: !isFormValid ? 0.6 : 1,
            }}
          >
            {loadingModal
              ? "Saving..."
              : editingTopic
              ? "Update Topic"
              : "Create Topic"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  renderDocumentModal = () => {
    const {
      showDocumentModal,
      selectedDocumentType,
      selectedFile,
      selectedTopic,
      loadingModal,
    } = this.state;

    return (
      <Modal
        show={showDocumentModal}
        onHide={this.handleCloseDocumentModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{ borderBottom: "1px solid #e0e0e0" }}>
          <Modal.Title style={{ color: "#3c4043" }}>
            📚 Add Material to {selectedTopic?.topic_name}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "24px" }}>
          {/* Document Type Selection */}
          <div className="form-group mb-4">
            <label
              style={{
                fontWeight: "500",
                color: "#3c4043",
                marginBottom: "12px",
              }}
            >
              Select Document Type *
              {selectedFile && (
                <small style={{ marginLeft: "8px", color: "#666" }}>
                  (Remove file to change type)
                </small>
              )}
            </label>
            <div className="row">
              {Object.entries(DOCUMENT_TYPES).map(([key, type]) => (
                <div key={key} className="col-md-6 mb-2">
                  <div
                    className={`document-type-option p-3 border rounded ${
                      !selectedFile ? "cursor-pointer" : ""
                    } ${
                      selectedDocumentType === key
                        ? "border-primary bg-light"
                        : "border-secondary"
                    } ${
                      selectedFile && selectedDocumentType !== key
                        ? "disabled"
                        : ""
                    }`}
                    onClick={() => this.handleDocumentTypeSelect(key)}
                    style={{
                      cursor:
                        selectedFile && selectedDocumentType !== key
                          ? "not-allowed"
                          : "pointer",
                      opacity:
                        selectedFile && selectedDocumentType !== key ? 0.5 : 1,
                      transition: "all 0.2s ease",
                      borderColor:
                        selectedDocumentType === key ? type.color : "#dadce0",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <span
                        style={{
                          fontSize: "20px",
                          marginRight: "8px",
                          color: type.color,
                        }}
                      >
                        {type.icon}
                      </span>
                      <span style={{ fontWeight: "500", color: "#3c4043" }}>
                        {type.name}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* File Upload Area */}
          {selectedDocumentType && (
            <div
              className="upload-area"
              style={{
                border: "2px dashed #ccc",
                borderRadius: "8px",
                padding: "40px",
                textAlign: "center",
                backgroundColor: "#fafafa",
              }}
            >
              <div className="mb-3">
                <span
                  style={{
                    fontSize: "48px",
                    color: DOCUMENT_TYPES[selectedDocumentType].color,
                  }}
                >
                  {DOCUMENT_TYPES[selectedDocumentType].icon}
                </span>
              </div>

              {!selectedFile ? (
                <>
                  <div className="custom-file mb-3">
                    <input
                      type="file"
                      className="custom-file-input"
                      id="documentFileInput"
                      onChange={this.handleFileChange}
                      style={{ display: "none" }}
                    />
                    <label
                      className="btn btn-outline-primary"
                      htmlFor="documentFileInput"
                      style={{ borderRadius: "24px", padding: "12px 24px" }}
                    >
                      Choose File
                    </label>
                  </div>
                </>
              ) : (
                <div
                  className="selected-file mt-3 p-3"
                  style={{
                    backgroundColor: "#e8f5e8",
                    borderRadius: "8px",
                    border: "1px solid #c8e6c9",
                    position: "relative",
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <strong>Selected: </strong>
                      <span style={{ color: "#2e7d32" }}>
                        {this.truncateFileName(selectedFile.name)}
                      </span>
                    </div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={this.handleFileRemove}
                      disabled={loadingModal}
                      style={{
                        borderRadius: "50%",
                        width: "32px",
                        height: "32px",
                        padding: "0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      title="Remove file"
                    >
                      ×
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #e0e0e0" }}>
          <Button
            variant="secondary"
            onClick={this.handleCloseDocumentModal}
            disabled={loadingModal}
            style={{ borderRadius: "20px" }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={this.handleDocumentUpload}
            disabled={loadingModal || !selectedFile || !selectedDocumentType}
            style={{ borderRadius: "20px" }}
          >
            {loadingModal
              ? "Uploading..."
              : `Upload ${
                  selectedDocumentType
                    ? DOCUMENT_TYPES[selectedDocumentType].name
                    : "Document"
                }`}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const {
      topics,
      loading,
      addVisibility,
      editVisibility,
      selectedFiles,
      breadcrumb2,
    } = this.state;

    const path = history.location.pathname;
    const formattedBreadcrumb = breadcrumb2
      ? breadcrumb2.replaceAll(">", " > ")
      : "";
    const isTeacher = editVisibility || addVisibility;
    const hasSelectedFiles = selectedFiles.length > 0;
    const totalDocuments = Array.from(
      this.state.topicDocuments.values()
    ).reduce((total, docs) => total + docs.length, 0);

    console.log("documents :", this.state.topicDocuments);

    // Show skeleton while loading
    if (loading) {
      return <CourseMaterialsSkeleton />;
    }

    return (
      <>
        <div
          style={{
            overflow: "auto",
            height: "90vh",
            backgroundColor: "#f8f9fa",
          }}
        >
          <ContentWrapper disabled={path === "/manage-search"}>
            {this.props.state.path !== "node" && (
              <p
                className="pt-4 pl-4"
                style={{ fontSize: "10.5625px", color: "#00000099" }}
              >
                {formattedBreadcrumb ? `${formattedBreadcrumb}` : ""}
              </p>
            )}

            <CardBody>
              {/* Header Section */}
              <div
                className="classroom-header mb-4"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  padding: "24px",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                  border: "1px solid #e0e0e0",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h2
                      className="mb-2"
                      style={{ color: "#3c4043", fontWeight: "400" }}
                    >
                      📚 Course Materials
                    </h2>
                    {isTeacher ? (
                      <p className="text-muted mb-0">
                        Organize and manage your learning materials by topics
                      </p>
                    ) : null}
                  </div>

                  {isTeacher && (
                    <button
                      onClick={this.handleCreateTopic}
                      style={{
                        backgroundColor: "#1976d2",
                        border: "1px solid #1976d2",
                        borderRadius: "8px",
                        padding: "12px 24px",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        transition: "all 0.2s ease",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = "#1565c0";
                        e.target.style.borderColor = "#1565c0";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "#1976d2";
                        e.target.style.borderColor = "#1976d2";
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                      </svg>
                      Create Topic
                    </button>
                  )}
                </div>

                {/* Statistics */}
                <div className="row">
                  <div className="col-md-4">
                    <div
                      className="stat-card text-center p-3"
                      style={{
                        backgroundColor: "#e3f2fd",
                        borderRadius: "8px",
                        border: "1px solid #bbdefb",
                      }}
                    >
                      <h4
                        className="mb-1"
                        style={{ color: "#1976d2", fontWeight: "600" }}
                      >
                        {topics.length}
                      </h4>
                      <small style={{ color: "#1976d2" }}>Topics Created</small>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className="stat-card text-center p-3"
                      style={{
                        backgroundColor: "#e8f5e8",
                        borderRadius: "8px",
                        border: "1px solid #c8e6c9",
                      }}
                    >
                      <h4
                        className="mb-1"
                        style={{ color: "#2e7d32", fontWeight: "600" }}
                      >
                        {totalDocuments}
                      </h4>
                      <small style={{ color: "#2e7d32" }}>
                        Total Materials
                      </small>
                    </div>
                  </div>
                </div>

                {/* Bulk Actions */}
                {hasSelectedFiles && (
                  <div
                    className="bulk-actions mt-4 p-3"
                    style={{
                      backgroundColor: "#e3f2fd",
                      borderRadius: "8px",
                      border: "1px solid #bbdefb",
                    }}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <input
                          type="checkbox"
                          className="mr-2"
                          checked={this.state.allSelected}
                          onChange={this.handleSelectAllFiles}
                          style={{ transform: "scale(1.2)" }}
                        />
                        <span style={{ color: "#1976d2", fontWeight: "500" }}>
                          {selectedFiles.length} file(s) selected
                        </span>
                      </div>
                      <button
                        onClick={this.handleDownloadSelectedFiles}
                        style={{
                          backgroundColor: "#1976d2",
                          border: "1px solid #1976d2",
                          borderRadius: "8px",
                          padding: "10px 20px",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor = "#1565c0";
                          e.target.style.borderColor = "#1565c0";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = "#1976d2";
                          e.target.style.borderColor = "#1976d2";
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                        </svg>
                        Download Selected
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Topics List */}
              <div className="topics-container">
                {topics.length === 0 ? (
                  <div
                    className="empty-state text-center py-5"
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <div className="mb-4">
                      <span style={{ fontSize: "64px", color: "#dadce0" }}>
                        📁
                      </span>
                    </div>
                    <h4 style={{ color: "#5f6368", fontWeight: "400" }}>
                      No Topics Created Yet
                    </h4>
                    {isTeacher && (
                      <p className="text-muted mb-4">
                        Start organizing your course materials by creating
                        topics
                      </p>
                    )}
                    {isTeacher && (
                      <button
                        onClick={this.handleCreateTopic}
                        style={{
                          backgroundColor: "#1976d2",
                          border: "1px solid #1976d2",
                          borderRadius: "8px",
                          padding: "12px 24px",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#fff",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor = "#1565c0";
                          e.target.style.borderColor = "#1565c0";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = "#1976d2";
                          e.target.style.borderColor = "#1976d2";
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                        </svg>
                        Create Your First Topic
                      </button>
                    )}
                  </div>
                ) : (
                  topics.map((topic) => this.renderTopicCard(topic))
                )}
              </div>

              {/* Modals */}
              {this.renderTopicModal()}
              {this.renderDocumentModal()}
            </CardBody>
          </ContentWrapper>
        </div>
        <style jsx>{`
          .document-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
          }

          .section-header:hover {
            background-color: #f0f0f0 !important;
          }

          .custom-file-label {
            cursor: pointer;
          }

          .document-actions .btn {
            transition: all 0.3s ease;
          }

          .document-actions .btn:hover {
            transform: scale(1.05);
          }

          .classroom-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
          }

          .classroom-header h2,
          .classroom-header p {
            color: white !important;
          }
        `}</style>
      </>
    );
  }
}

export default ManageDocuments;
